import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';

export class WebSocketReceiveReloadCompany extends WebSocketReceiveWithSigningUserId {}
